import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { Attribution, ErrorBoundary } from '@confluence/error-boundary';

import { useAudioPlaybackState } from '../hooks/useAudioPlaybackState';

import { Miniplayer } from './Miniplayer';

const floatingStyles = xcss({
	width: '300px',
	position: 'fixed',
	top: '110px',
	right: 'space.600',
	zIndex: 'modal',
	backgroundColor: 'elevation.surface.overlay',
	boxShadow: 'elevation.shadow.overlay',
	borderRadius: 'border.radius.300',
});

export const FloatingMiniplayer = () => {
	const [{ activeContent, audioContext, audioSrcUrl }] = useAudioPlaybackState();

	// Prevent clicking from blurring/closing other UI elements like modals/dialogs
	const stopClickPropagation = (e) => e.stopPropagation();
	if (activeContent && audioContext && audioSrcUrl) {
		return (
			<ErrorBoundary attribution={Attribution.SMARTS}>
				<Box
					xcss={floatingStyles}
					onClick={stopClickPropagation}
					testId="audio-floating-miniplayer"
				>
					<Miniplayer />
				</Box>
			</ErrorBoundary>
		);
	}

	return null;
};
